const site = site || {};
site.Utilities = (() => {
    // Functions

    // const functionName = () => {
    //
    // };

    const loadWidgetScripts = () => {
        let scriptsToLoad = [];
        const jsWidget = document.querySelectorAll('[data-scripts]');
        jsWidget.forEach((widget) => {
            const widgetScripts = widget.getAttribute('data-scripts');
            let widgetScriptsArray = widgetScripts.split(",");
            widgetScriptsArray.forEach((src) => {
                let scriptSrcTrimmed = src.trim();
                if (!scriptsToLoad.includes(scriptSrcTrimmed)) {
                    scriptsToLoad.push(scriptSrcTrimmed);
                }
            });
        });
        scriptsToLoad.forEach(function (index, value) {
            setTimeout(function () {
                let newScript = document.createElement('script');
                newScript.type = 'text/javascript';
                newScript.src = index;
                // newScript.defer = true;
                document.getElementsByTagName('body')[0].appendChild(newScript);
            }, 250 * value);
        });
    }

    const setLeftOffset = () => {
        const offsetElement = document.querySelectorAll('.js-left-offset');
        if (offsetElement) {
            offsetElement.forEach(element => {
                const containerOffsetLeft = document.querySelector('.container').offsetLeft + 12 + "px";
                element.style.marginLeft = containerOffsetLeft;
                
            });
        }
    }

    const modalNavOverflow = () => {
        const modalNav = document.querySelector('.js-modal-nav');
        const modalNavTrigger = document.querySelector('.js-modal-nav-trigger');
        const modalNavCloseButton = document.querySelector('.js-modal-nav-close');
        
        modalNavTrigger.addEventListener('click', () => {
            document.querySelector('html').classList.add('overflow-y-hidden');
        });
        modalNavCloseButton.addEventListener('click', () => {
            document.querySelector('html').classList.remove('overflow-y-hidden')
        });
        modalNav.addEventListener('keydown', function(event) {
            const key = event.key; // const {key} = event; in ES6+
            if (key === "Escape") {
                document.querySelector('html').classList.remove('overflow-y-hidden')
            }
        });
    }

    const tiltBadge = () => {
        function isTouchDevice(){
            return window.matchMedia('(hover: none)').matches;
        }
        if(!isTouchDevice()) {
            const tiltContainers = document.querySelectorAll(".js-tilt-container");
            
            tiltContainers.forEach(tiltContainer => {
    
                const tiltObject = tiltContainer.querySelector(".js-tilt-object");
        
                const settings = {
                    reverse: 1,           // Reverse tilt: 1, 0
                    max: 80,             // Max degrees of rotaion
                    perspective: -10,    // Parent perspective px: 1000
                    scale: 1.00,             // Tilt element scale factor: 1.0
                    axis: "",             // Limit axis. "y", "x"
                };
        
                if (tiltObject) {
                    tiltContainer.style.perspective = `${settings.perspective}px`;
            
                    const tilt = (event) => {
                        const bcr = tiltContainer.getBoundingClientRect();
                        const x = Math.min(1, Math.max(0, (event.clientX - bcr.left) / bcr.width));
                        const y = Math.min(1, Math.max(0, (event.clientY - bcr.top) / bcr.height));
                        const reverse = settings.reverse ? -1 : 1;
                        const tiltX = reverse * (settings.max / 2 - x * settings.max);
                        const tiltY = reverse * (y * settings.max - settings.max / 2);
                    
                        tiltObject.style.transform = `
                            rotateX(${settings.axis === "x" ? 0 : tiltY}deg)
                            rotateY(${settings.axis === "y" ? 0 : tiltX}deg)
                            scale(${settings.scale})
                        `;
                        tiltObject.style.transition = `none`
                    }
            
                    tiltContainer.addEventListener("pointermove", tilt);
                    tiltContainer.addEventListener("mouseout", () => {
                        tiltObject.style.transform = `rotateX(0) rotateY(0) scale(1)`;     
                        tiltObject.style.transition = `all 5000ms cubic-bezier(0.680, -0.550, 0.265, 1.550)`
                    })
                }
            });
        
        }
    }

    const formHandler = () => {

        const newsletterFormHandler = () => {
            const newsletterForm = document.querySelector('.hubspot-form');
            
            if(newsletterForm) {
                const formLabels = document.querySelectorAll('label')

                formLabels.forEach((label) => {
                    label.classList.add('sr-only');
                    clearInterval(formHandlerInterval);

                })
            } 
        }
        const formHandlerInterval = setInterval(newsletterFormHandler, 1000);
    }

    const showMore = () => {
        const showMoreButtons = document.querySelectorAll('.js-show-more-button')
        if (showMoreButtons) {
            showMoreButtons.forEach((button) => {
                button.addEventListener('click', () => {
                    const buttonText = button.querySelectorAll('.js-show-more-text');
                    const buttonIcon = button.querySelectorAll('.js-show-more-icon');
                    console.log('click');
                    buttonText.forEach((text) => {
                        text.classList.toggle('d-none');
                    })
                    buttonIcon.forEach((icon) => {
                        icon.classList.toggle('d-none');
                    })
                })  
            })
        }
    }


    // Return
    return {
        // functionName : functionName
        loadWidgetScripts : loadWidgetScripts,
        modalNavOverflow : modalNavOverflow,
        setLeftOffset : setLeftOffset,
        tiltBadge : tiltBadge,
        showMore : showMore,
        formHandler : formHandler

    };
})();